export class IQMQStepIds {
  public static readonly LetsGetStarted = 'LetsGetStarted'.toLowerCase();
  public static readonly StartYourQuote = 'StartYourQuote'.toLowerCase();
  public static readonly FindYourCar = 'FindYourCar'.toLowerCase();
  public static readonly SelectYourCover = 'SelectYourCover'.toLowerCase();
  public static readonly YourCarDetails = 'YourCarDetails'.toLowerCase();
  public static readonly PrimaryDriverDetails = 'PrimaryDriverDetails'.toLowerCase();
  public static readonly YourQuote = 'YourQuote'.toLowerCase();
}

export const IQMQFinanceTypes = {
  NOFINANCE: 'NOFINANCE',
  RACQFINANCE: 'RACQFINANCE',
  SECURED: 'SECURED',
  UNSECURED: 'UNSECURED',
  LEASE: 'LEASE',
};
